import * as React from "react";
import { legacyClients } from "../legacyClients/legacyClients";
import { abuseClient } from "../generated/abuse";
import { adminClient } from "../generated/admin";
import { cmsClient } from "../generated/cms";
import { communityClient } from "../generated/community";
import { competitionsClient } from "../generated/competitions";
import { competitionsLegacyClient } from "../generated/competitions/legacy";
import { datasetsClient } from "../generated/datasets";
import { datasetsDatabundlesClient } from "../generated/datasets/databundles";
import { discussionsClient } from "../generated/discussions";
import { educationClient } from "../generated/education";
import { kernelsClient } from "../generated/kernels";
import { modelsClient } from "../generated/models";
import { notificationsClient } from "../generated/notifications";
import { searchClient } from "../generated/search";
import { tagsClient } from "../generated/tags";
import { userSecretsClient } from "../generated/user_secrets";
import { usersClient } from "../generated/users";
export var bothClients = {
    clients: {
        abuseClient: abuseClient,
        adminClient: adminClient,
        cmsClient: cmsClient,
        communityClient: communityClient,
        competitionsClient: competitionsClient,
        competitionsLegacyClient: competitionsLegacyClient,
        datasetsClient: datasetsClient,
        datasetsDatabundlesClient: datasetsDatabundlesClient,
        discussionsClient: discussionsClient,
        educationClient: educationClient,
        kernelsClient: kernelsClient,
        modelsClient: modelsClient,
        notificationsClient: notificationsClient,
        searchClient: searchClient,
        tagsClient: tagsClient,
        usersClient: usersClient,
        userSecretsClient: userSecretsClient
    },
    legacyClients: legacyClients
};
export var ClientsContext = /*#__PURE__*/ React.createContext(bothClients);
